import { render, staticRenderFns } from "./DynamicSingleChoice.vue?vue&type=template&id=b1650592&scoped=true"
import script from "./DynamicSingleChoice.vue?vue&type=script&lang=js"
export * from "./DynamicSingleChoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1650592",
  null
  
)

export default component.exports